// extracted by mini-css-extract-plugin
module.exports = {"LayoutStyles":"Layout_LayoutStyles__2U0cE"};